<script setup>
import PortalShell from '@/Layouts/PortalShell.vue'
</script>

<template>
  <PortalShell portal="host">
    <slot />
  </PortalShell>
</template>
